module.exports = __webpack_public_path__ + "static/media/ventac.d64ec5c0.png";